import axios from 'axios'
import errorHandlerRest from './errorHandlerRest'
import { Cookie } from '@/mixin/local-cookie'

const axiosConfig = {
  baseURL: process.env.VUE_APP_API_SMS_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
}

// When developing locally, the cookie 'resource' cookie is not available
// in the browser (httpOnly).
// So we need to manually copy the cookie after identity login
// and paste it to the localhost cookie
const localCookie = Cookie.getLocalCookie()

// If the local cookie is found (not httpOnly), then use it
// if not, then use the httpOnly cookie, using withCredentials flag
if (localCookie?.resource) {
  axiosConfig.headers.Authorization = `Bearer ${localCookie?.resource}`
} else {
  axiosConfig.withCredentials = true
}

const apiClient = axios.create(axiosConfig)

apiClient.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return errorHandlerRest(error)
  }
)

export default apiClient
